import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    notifications: [],
    isPaymentModalProcessing: false
  },
  reducers: {
    enqueueSnackbar(state, action) {
      // Dedupe por mensaje: el middleware de sagas y el errorHandler de Apollo pueden
      // reportar el MISMO fallo por separado (doble toast). Si un toast vivo con el mismo
      // texto se encoló hace <2s, el nuevo se descarta.
      const incoming = action.payload.notification;
      const now = Date.now();
      const isDuplicate = state.notifications.some(
        (n) => !n.dismissed && n.message === incoming.message && now - (n.enqueuedAt || 0) < 2000
      );

      if (isDuplicate) return;

      state.notifications = [
        ...state.notifications,
        {
          key: action.payload.key,
          enqueuedAt: now,
          ...incoming
        }
      ];
    },
    closeSnackbar(state, action) {
      state.notifications = state.notifications.map((notification) =>
        action.payload.dismissAll || notification.key === action.payload.key
          ? { ...notification, dismissed: true }
          : notification
      );
    },
    removeSnackbar(state, action) {
      state.notifications = state.notifications.filter(
        (notification) => notification.key !== action.payload
      );
    },
    setPaymentModalProcessing(state, action) {
      state.isPaymentModalProcessing = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => ({
      notifications: [],
      isPaymentModalProcessing: false
    }));
  }
});

export default uiSlice;
